import { WEB_SOCKET_DOMAIN } from "../../../utility/constants";
import SubscribingComponent from "./subscribing-component";
import { Card } from "@mui/material";
import styles from "./styles";
import { useContext, useEffect, useRef, useState } from "react";
import { ExportReportContext } from "../../../context/exportReportContext";
import { Client } from "@stomp/stompjs";

const ExportLoader = () => {
  const { exports, setExports, setShow } = useContext(ExportReportContext);

  const [arConnected, setArConnected] = useState<boolean>(false);
  const [invConnected, setInvConnected] = useState<boolean>(false);
  const arClientRef = useRef<Client | null>(null);
  const invClientRef = useRef<Client | null>(null);

  useEffect(() => {
    const client = new Client({
      webSocketFactory: () => new WebSocket(`${WEB_SOCKET_DOMAIN}/calc`),
      reconnectDelay: 5000,
      debug: () => {}, // Disable noisy logs; add `console.log` if needed
    });

    client.onConnect = (frame) => {
      setArConnected(true);
    };

    client.onStompError = (frame) => {
      console.error('❌ STOMP error:', frame.headers['message'], frame.body);
    };

    client.onWebSocketError = (error) => {
      console.error('❌ WebSocket error:', error);
    };

    client.activate();
    arClientRef.current = client;

    return () => {
      client.deactivate();
      setArConnected(false);
    };
  }, []);

  useEffect(() => {
    const client = new Client({
      webSocketFactory: () => new WebSocket(`${WEB_SOCKET_DOMAIN}/inventory-ws`),
      reconnectDelay: 5000,
      debug: () => {}, // Disable noisy logs; add `console.log` if needed
    });

    client.onConnect = (frame) => {
      setInvConnected(true);
    };

    client.onStompError = (frame) => {
      console.error('❌ STOMP error:', frame.headers['message'], frame.body);
    };

    client.onWebSocketError = (error) => {
      console.error('❌ WebSocket error:', error);
    };

    client.activate();
    invClientRef.current = client;

    return () => {
      client.deactivate();
      setInvConnected(false);
    };
  }, []);

  return (
    <Card variant="outlined" sx={styles.container}>
      {arConnected && invConnected &&
      <SubscribingComponent
        exports={exports}
        setExports={setExports}
        setShow={setShow}
        stompClient={{
          arClient: arClientRef.current,
          invClient: invClientRef.current
        }}
      />}
    </Card>
  )
}

export default ExportLoader;